export const initialState = {
  masters: {},
};
const masterDataReducer = (state: any, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case "SAVE_MASTERDATA":
      return {
        ...state,
        masters: { ...state.masters, ...payload },
      };
    case "REMOVE_MASTERDATA":
      return {
        ...state,
        masters: { ...state.masters, ...payload },
      };
    case "CLEAR_MASTERDATA":
      return {
        ...state,
        masters: null, // Resetting masters to null
      };
    default:
      throw new Error(`No case for type ${type} found in masterDataReducer.`);
  }
};

export default masterDataReducer;
